export var TABLE_EXPANDABLE_SECTION_CLASS_PREFIX = 'TableExpandableSection';